import React, { useContext } from "react";
import { AppContextType, WonmovContext } from "@/context/app-context";
import walletIcon from "@public/img/wallet.svg";

export default function ProfilePage() {
    const { vipData, user } = useContext<AppContextType>(WonmovContext);

    return (
        <div className="profile-dashboard">
            <div className="profile-dashboard__card profile-dashboard__card--vip bg-main-radial-gradient-r">
                <div className="profile-vip-card__days-wrap">
                    <div className="profile-vip-card__days">
                        <span className="profile-vip-card__days-value">
                            {vipData && vipData.days_left !== undefined ? vipData.days_left : 0}
                        </span>
                        <span className="profile-vip-card__days-label">روز مانده</span>
                    </div>
                </div>
                <div className="profile-vip-card__info">
                    <p className="profile-vip-card__info-label">تاریخ پایان اشتراک:</p>
                    <p className="profile-vip-card__info-date">
                        {vipData && vipData.end_date ? vipData.end_date : ""}
                    </p>
                </div>
            </div>

            <div className="profile-dashboard__card profile-dashboard__card--stat bg-main-radial-gradient-t">
                <p className="profile-stat-card__value">0</p>
                <p className="profile-stat-card__label">لیست تماشا</p>
            </div>

            <div className="profile-dashboard__card profile-dashboard__card--stat bg-main-radial-gradient-t">
                <p className="profile-stat-card__value">0</p>
                <p className="profile-stat-card__label">دیدگاه</p>
            </div>

            <div className="profile-dashboard__card profile-dashboard__card--wallet bg-main-radial-gradient-l">
                <img src={walletIcon} alt="wallet" className="profile-wallet-card__icon" />
                <div className="profile-wallet-card__info">
                    <p className="profile-wallet-card__info-label">موجودی کیف پول:</p>
                    <p className="profile-wallet-card__info-balance">
                        <span className="profile-wallet-card__info-amount">
                            {user && user.wallet_balance !== undefined ? user.wallet_balance : 0}
                        </span>
                        {" "}تومان
                    </p>
                </div>
            </div>
        </div>
    );
}
